import React from 'react';
import Button from '@material-ui/core/Button';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import Grid from '@material-ui/core/Grid';
import AddCircle from '@material-ui/icons/AddCircle';
import SearchIcon from '@material-ui/icons/Search';
import TicketCard from './components/TicketCard';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SubHeaderTickets from './../components/SubHeaders/ProjectSubHeader';
import { connect } from 'react-redux';
import { getCurrentProject } from 'Actions/ticketActions';
import { Link } from 'react-router-dom';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import moment from 'moment';
import {
  downloadExportedFile,
  getUsersAccepted,
  getUsersInvited,
  projectSuccess,
} from 'Actions/projectActions';
import ProjectsMenu from './../components/ProjectsMenu';
import { pathToFileURL } from 'url';
import styled from 'styled-components';
import ImportExcel from '../ImportExcel/ImportExcel';
import IssueDraft from '../components/IssueDraft/IssueDraft';
import CriteriaErrors from '../components/CriteriaErrors/CriteriaErrors';
import Success from '../../../../../../src/components/supply/components/Success/index';

const Container = styled.div`
  max-width: 1024px;
`;

class SingleProject extends React.Component {
  state = {
    newProjectDialogOpen: false,
    ticketFilter: '',
    filteredTickets: [],
    tickets: [],
    hasTickets: false,
    filterByStatus: 'ALL',
    file: null,
    IssueDraftOpen: false,
    snackbarOpen: false,
  };

  componentDidMount() {
    this.props.getCurrentProject(this.props.match.params.projectId);
    this.props.setCurrentProjectId(this.props.match.params.projectId);
    if (
      this.props.projects &&
      this.props.projects.length &&
      this.props.projects[0].creator
    ) {
      this.props.getUsersInvited(this.props.match.params.projectId);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.match.params.projectId &&
      this.props.match.params.projectId !== nextProps.match.params.projectId
    ) {
      this.props.getCurrentProject(nextProps.match.params.projectId);
      this.props.setCurrentProjectId(nextProps.match.params.projectId);
      if (
        this.props.projects &&
        this.props.projects.length &&
        this.props.projects[0].creator
      ) {
        this.props.getUsersInvited(this.props.match.params.projectId);
      }
      this.setState({ ticketFilter: '', filterByStatus: '' });
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    //handling delete of current project
    if (
      this.props.projects.length > 0 &&
      nextProps.projects.find(
        project =>
          project.id.toString() === nextProps.match.params.projectId.toString()
      ) === undefined
    ) {
      // this.props.history.push('/demand');
    }

    let tickets = nextProps.tickets;
    let hasTickets = false;
    if (tickets) {
      if (tickets.length > 0) {
        hasTickets = true;
      }

      this.setState({ tickets, hasTickets }, () => {
        if (!this.state.filteredTickets && tickets.length > 0) {
          this.setState({ filteredTickets: tickets });
        }
        this.filterTickets(this.state.tickets);
        //TODO resi filtriranje
      });
    }
  }

  handleFilterTickets = name => event => {
    this.setState({ [name]: event.target.value }, () =>
      this.filterTickets(this.state.tickets)
    );
  };
  filterTickets = ticketsArray => {
    let filteredTickets;
    switch (this.state.filterByStatus) {
      case 'DRAFT':
        filteredTickets = ticketsArray
          .filter(ticket => ticket.state === 'DRAFT')
          .filter(ticket =>
            Object.keys(ticket).some(key => {
              return String(ticket[key])
                .toLowerCase()
                .includes(
                  String(this.state.ticketFilter)
                    .toLowerCase()
                    .trim()
                );
            })
          );
        break;
      case 'EXPIRED':
        filteredTickets = ticketsArray
          .filter(
            ticket => ticket.expiration && moment().isAfter(ticket.expiration)
          )
          .filter(ticket =>
            Object.keys(ticket).some(key => {
              return String(ticket[key])
                .toLowerCase()
                .includes(
                  String(this.state.ticketFilter)
                    .toLowerCase()
                    .trim()
                );
            })
          );
        break;
      case 'ACTIVE':
        filteredTickets = ticketsArray
          .filter(
            ticket =>
              !ticket.expiration ||
              (ticket.expiration && moment().isBefore(ticket.expiration))
          )
          .filter(ticket =>
            Object.keys(ticket).some(key => {
              return String(ticket[key])
                .toLowerCase()
                .includes(
                  String(this.state.ticketFilter)
                    .toLowerCase()
                    .trim()
                );
            })
          );
        break;
      default:
        filteredTickets = ticketsArray.filter(ticket =>
          Object.keys(ticket).some(key => {
            return String(ticket[key])
              .toLowerCase()
              .includes(
                String(this.state.ticketFilter)
                  .toLowerCase()
                  .trim()
              );
          })
        );
    }
    this.setState({ filteredTickets });
  };
  handleOpen = () => {
    this.setState({ newProjectDialogOpen: true });
  };

  handleClose = () => {
    this.setState({ newProjectDialogOpen: false });
  };

  handleIssueDraftClose = () => {
    this.setState({ IssueDraftOpen: false });
  };

  handleIssueDraftOpen = () => {
    this.setState({ IssueDraftOpen: true });
  };

  onFileChange(e) {
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    this.setState({ file: formData });
  }

  handleFilterTicketsByStatus = name => event => {
    this.setState({ [name]: event.target.value }, () =>
      this.filterTickets(this.state.tickets)
    );
  };
  renderTickets = () => {
    return this.state.filteredTickets.map(ticket => {
      let newSlipsCount = this.props.notifications.filter(
        notif =>
          notif.ticketId == ticket.ticketId &&
          notif.notificationType === 'NEW_SLIP'
      ).length;
      let updatedSlipsCount = this.props.notifications.filter(
        notif =>
          notif.ticketId == ticket.ticketId &&
          notif.notificationType === 'UPDATED_SLIP'
      ).length;
      return (
        <TicketCard
          key={ticket.ticketId}
          ticket={ticket}
          favorite={ticket.favorite}
          projectId={this.props.match.params.projectId}
          newSlipsCount={newSlipsCount > 0 ? newSlipsCount : false}
          updatedSlipsCount={updatedSlipsCount > 0 ? updatedSlipsCount : false}
          history={this.props.history}
        />
      );
    });
  };

  renderExpiringScale = ticket => {
    if (ticket && ticket.expiration) {
      const start = moment(ticket.created);
      const end = moment(ticket.expiration);

      const current = moment();
      return 100 * (current.diff(start, 'days') / end.diff(start, 'days'));
    } else {
      return false;
    }
  };

  render() {
    this.renderExpiringScale();
    let usersInvited = this.props.usersInvited
      ? this.props.usersInvited.filter(user => user.state === 'ACTIVE')
      : [];
    let users = this.props.users
      ? this.props.users.filter(user => user.state === 'ACTIVE')
      : [];
    return (
      <Grid item className="flex-dashboard">
        <SubHeaderTickets
          handleOpenShareDialog={this.props.handleOpenShareDialog}
          //project={this.props.currentProject} because live update will no work after edit
          project={this.props.projects.find(
            project =>
              this.props.currentProject &&
              project.id == this.props.match.params.projectId
          )}
          created={
            this.props.currentProject ? this.props.currentProject.created : null
          }
          creator={
            this.props.currentProject
              ? this.props.currentProject.creatorId
              : false
          }
          currentUser={this.props.currentUser}
          allUsers={usersInvited}
          users={users}
          history={this.props.history}
        />
        <ProjectsMenu openProjectsSidebar={this.props.openProjectsSidebar} />
        <ImportExcel
          file={this.state.file}
          onClose={() => this.setState({ file: null })}
          projectId={this.props.match.params.projectId}
        />
        <IssueDraft
          open={this.state.IssueDraftOpen}
          tickets={this.state.filteredTickets}
          onClose={this.handleIssueDraftClose}
          projectId={this.props.match.params.projectId}
        />
        <CriteriaErrors />
        <Success
          open={this.props.successMessage !== null}
          message={this.props.successMessage}
          handleClose={() => this.props.projectSuccess(null)}
        />
        <div className="dash-padding">
          <Container>
            <div className="u-mrg-top-neg-45">
              <Grid
                container
                justify={'space-between'}
                alignItems={'center'}
                className="search-tickets"
              >
                <Grid item md={6} lg={4} className="u-pad-r-10">
                  <FormControl className="w100">
                    <InputLabel
                      htmlFor="search"
                      classes={{
                        root: 'label--c-gray',
                      }}
                    >
                      Search
                    </InputLabel>
                    <Input
                      classes={{
                        underline: 'underline--c-primary',
                      }}
                      id="email"
                      type="text"
                      label="Search projects"
                      value={this.state.ticketFilter}
                      onChange={this.handleFilterTickets('ticketFilter')}
                    />
                  </FormControl>
                </Grid>
                <FormControl>
                  <Select
                    disableUnderline
                    // native
                    value={this.state.filterByStatus}
                    onChange={this.handleFilterTicketsByStatus(
                      'filterByStatus'
                    )}
                    inputProps={{
                      id: 'filter',
                    }}
                  >
                    <MenuItem value={'ALL'}>All</MenuItem>
                    <MenuItem value={'ACTIVE'}>Active</MenuItem>
                    <MenuItem value={'DRAFT'}>Draft</MenuItem>
                    <MenuItem value={'EXPIRED'}>Expired</MenuItem>

                    {/* <option value={'ALL'}>All</option>
                    <option value={'ACTIVE'}>Active</option>
                    <option value={'DRAFT'}>Draft</option>
                    <option value={'EXPIRED'}>Expired</option> */}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                container
                className="dashboard-tickets"
                alignItems={'flex-start'}
                justify={'flex-start'}
                spacing={16}
              >
                <Grid item xs={12} md={6} lg={3}>
                  <Link
                    to={{
                      pathname: `/demand/project/${this.props.match.params.projectId}/ticket/create`,
                      state: {
                        projectId: this.props.match.params.projectId,
                        currentProject: this.props.currentProject,
                      },
                    }}
                    className="dashboard-new-ticket card-shadow"
                  >
                    <AddCircle className="add-new-ticket-icon" />
                    <h2>Create new Search</h2>
                  </Link>
                </Grid>

                <Grid item xs={12} md={6} lg={3}>
                  <Link
                    to={{
                      pathname: `/demand/project/${this.props.match.params.projectId}/ticket/internalSearch`,
                      state: { projectId: this.props.match.params.projectId },
                    }}
                    className="dashboard-new-ticket card-shadow"
                  >
                    <SearchIcon className="add-new-ticket-icon" />
                    <h2>Search internal luminaire database</h2>
                  </Link>
                </Grid>

                <Grid item xs={12} md={6} lg={3}>
                  <div className="dashboard-new-ticket card-shadow">
                    <input
                      className="hide-native-file-upload-custom"
                      name="criteriaImage"
                      type="file"
                      onChange={event => this.onFileChange(event)}
                      value=""
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                    <PublishIcon className="add-new-ticket-icon" />
                    <h2>Import Luminaire Schedule</h2>
                  </div>
                </Grid>

                <Grid item xs={12} md={6} lg={3}>
                  <div
                    className="dashboard-new-ticket card-shadow"
                    onClick={() =>
                      this.props.downloadExportedFile(
                        this.props.match.params.projectId
                      )
                    }
                  >
                    <GetAppIcon className="add-new-ticket-icon" />
                    <h2>Export Luminaire Schedule</h2>
                  </div>
                </Grid>

                {this.renderTickets()}

                <Grid item xs={12} md={12} lg={12}>
                  <Button
                    onClick={this.handleIssueDraftOpen}
                    variant="contained"
                    color="primary"
                  >
                    ISSUE DRAFT SEARCHES
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Container>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = store => {
  return {
    projects: store.projects.projects,
    projectUsages: store.projects.projectUsages,
    tickets: store.currentProject.tickets,
    currentProject: store.currentProject.project,
    users: store.initialData.users,
    usersInvited: store.projects.usersInvited,
    currentUser: store.user.user.userId,
    successMessage: store.projects.successMessage,
  };
};
const mapDispatchToProps = dispatch => ({
  getCurrentProject: projectId => {
    dispatch(getCurrentProject(projectId));
  },
  getUsersInvited: projectId => {
    dispatch(getUsersInvited(projectId));
  },
  downloadExportedFile: projectId => {
    dispatch(downloadExportedFile(projectId));
  },
  projectSuccess: message => {
    dispatch(projectSuccess(message));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(SingleProject);
